<template>
  <div class="version-list">
    <div class="list" v-for="(item, i) in version" :key="i">
      <div class="text-con" @click="goVersion(item.ver)">
        <div class="text">{{ item.appName +' '+ item.ver }} 更新说明</div>
        <div class="date">{{ item.date }}</div>
      </div>
      <div class="icon-con" @click="goVersion(item.ver)"></div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      version: [
        {appName: '云柑社区', ver: '3.1.0', date: '2020-11-11'},
        {appName: '云柑社区', ver: '3.0.0', date: '2020-10-17'},
        {appName: '蚂蚁报信', ver: '1.5.5', date: '2020-03-03'},
        {appName: '蚂蚁报信', ver: '1.5.3', date: '2020-01-18'},
        {appName: '蚂蚁报信', ver: '1.5.2', date: '2020-01-06'},
        {appName: '蚂蚁报信', ver: '1.5.0', date: '2019-12-15'},
        {appName: '蚂蚁报信', ver: '1.4.1', date: '2019-11-23'},
        {appName: '蚂蚁报信', ver: '1.4.0', date: '2019-11-18'},
        {appName: '蚂蚁报信', ver: '1.3.3', date: '2019-11-08'},
        {appName: '蚂蚁报信', ver: '1.3.0', date: '2019-08-27'},
        {appName: '蚂蚁报信', ver: '1.2.0', date: '2019-07-16'},
        {appName: '蚂蚁报信', ver: '1.1.6', date: '2019-05-06'},
        {appName: '蚂蚁报信', ver: '1.1.5', date: '2019-04-12'}
      ]
    }
  },
  methods: {
    goVersion(ver){
      this.$router.push({ name: 'versionIOSDetail', params: { ver } })
    }
  }
}
</script>

<style lang="less" scoped>
.version-list{
  padding: 12px;
  .list{
    height: 60px;
    padding: 12px 0;
    display: flex;align-items: center;
    border-bottom: 1px solid #ededed;
    &:last-child{
      border-bottom: none;
    }
    .text-con{
      flex: 1;
      .text{
        font-size: 14px;
        padding-bottom: 4px;
      }
      .date{
        font-size: 12px;
      }
    }
    .icon-con{
      width: 40px;height: 100%;
      background: url("./img/right-icon.png") no-repeat 50% 50%;
      background-size: 8px 17px;
    }
  }
}
</style>